const mergeInvoiceDocumentFinanceState = (invoice, node) => ({
  ...invoice,
  uniqueDocumentFinanceState:
    node?.uniqueDocumentFinanceState
    ?? invoice.uniqueDocumentFinanceState
    ?? [],
  lightningPaymentState:
    node?.lightningPaymentState
    ?? invoice.lightningPaymentState,
});

export default mergeInvoiceDocumentFinanceState;
